import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


import { GoogleOAuthProvider } from '@react-oauth/google';

ReactDOM.createRoot(document.getElementById('root')).render(
  <GoogleOAuthProvider
    clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
  >
    <App />
  </GoogleOAuthProvider>
);